<template>
  <div class="subPage_container" style="padding-top:60px">
    <AllBrief :boardList="this.briefList" :tableComponent="BriefTable" />
  </div>
</template>

<script>
import AllBrief from "./sub/BriefView.vue";
import BriefTable from "./sub/BriefTable.vue";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "BriefPage",
  components: {
    AllBrief,
  },
  data() {
    return {
      BriefTable,
      briefList: [],
    };
  },
  async mounted() {
    await this.connectBrief();
  },
  computed: {
    ...mapState("board", [
      "brief",
      "currentTab",
      "langSelect",
    ]),

    subPath() {
      return this.$route.path.split("/")[2];
    },
  },
  methods: {
    ...mapActions("board", [
      "getAMBrief",
      "getPMBrief",
      "getPickBrief",
      "getAMAll",
      "getPMAll",
      "getPickAll",
      "changeTab",
    ]),

    ...mapMutations("board", ["langClick", "changeLang"]),

    // 오전/오후 & 언어 선택 여부에 따른 리스트 불러오는 함수
    async connectBrief() {
      const language = localStorage.getItem("patchLang") || "default";

      if (this.currentTab === "am-brief" && language != "default") {
        await this.getAMBrief();
      } else if (this.currentTab === "am-brief" && language === "default") {
        await this.getAMAll();
      } else if (this.currentTab === "pm-brief" && language != "default") {
        await this.getPMBrief();
      } else if (this.currentTab === "pm-brief" && language === "default") {
        await this.getPMAll();
      } else if (this.currentTab === "pick-brief" && language != "default") {
        await this.getPickBrief();
      } else if (this.currentTab === "pick-brief" && language === "default") {
        await this.getPickAll();
      }
      this.briefList = this.brief;
    },
  },

  watch: {
    // 오전&오후 탭 변경 때마다 작동
    currentTab() {
      this.connectBrief();
      this.langClick({ state: false });
    },
    // 선택된 언어 변경시마다 작동
    langSelect(newVal, oldVal) {
      if (newVal != oldVal && this.subPath === "brief") {
        // console.log("brief");
        this.connectBrief();
        this.$router.push("/board/brief");
      }
    },
  },
};
</script>
